import { useEffect, useMemo } from 'react'
import { type IResponseFullCampaign } from 'entities/Campaign'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { CampaignView } from 'pages/campaigns/ui/CampaignView'
import { CampaignViewStore } from 'pages/campaigns/ui/CampaignView/store/CampaignViewStore'
import { useCampaignsPageContext } from 'pages/campaigns/context/context'

export const CreateCampaign = () => {
  const entities = useEntitiesContext()
  const { pageLayoutStore } = useCampaignsPageContext()
  const store = useMemo(() => new CampaignViewStore(entities), [])

  useEffect(() => {
    const campaign = sessionStorage.getItem('campaign')
    if (campaign) {
      const response: IResponseFullCampaign = campaign ? JSON.parse(campaign) : undefined
      store.init(response)
      sessionStorage.removeItem('campaign')
    }
    return () => {
      store.dispose()
    }
  }, [])

  return <CampaignView store={store} pageLayoutStore={pageLayoutStore} />
}
